export const FEED_EVENTS_CONTAINER_ID = 'feed-events';
